
const _ = require('lodash');

const moment = require('moment');

// WORKAROUND: https://github.com/moment/moment/issues/3019
// TODO: Use `moment.ISO_8601` instead
const DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSSSZ';
const momentRepr = _.partial(moment, _, DATE_FORMAT);
const momentReprExtend = { repr: { moment: momentRepr } };

module.exports = {
	DATE_FORMAT,
	momentRepr,
	momentReprExtend,
};
